/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_DiscardInputs */

const en_jobs_discard = /** @type {(inputs: Jobs_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard`)
};

const de_jobs_discard = /** @type {(inputs: Jobs_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerfen`)
};

const fr_jobs_discard = /** @type {(inputs: Jobs_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const es_jobs_discard = /** @type {(inputs: Jobs_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar`)
};

const it_jobs_discard = /** @type {(inputs: Jobs_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarta`)
};

const nl_jobs_discard = /** @type {(inputs: Jobs_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerpen`)
};

const pl_jobs_discard = /** @type {(inputs: Jobs_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odrzuć`)
};

const fi_jobs_discard = /** @type {(inputs: Jobs_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hylkää`)
};

const da_jobs_discard = /** @type {(inputs: Jobs_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kassér`)
};

const sv_jobs_discard = /** @type {(inputs: Jobs_DiscardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kassera`)
};

/**
* | output |
* | --- |
* | "Discard" |
*
* @param {Jobs_DiscardInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_discard = /** @type {((inputs?: Jobs_DiscardInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_DiscardInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_discard(inputs)
	if (locale === "fr") return fr_jobs_discard(inputs)
	if (locale === "es") return es_jobs_discard(inputs)
	if (locale === "it") return it_jobs_discard(inputs)
	if (locale === "nl") return nl_jobs_discard(inputs)
	if (locale === "pl") return pl_jobs_discard(inputs)
	if (locale === "fi") return fi_jobs_discard(inputs)
	if (locale === "da") return da_jobs_discard(inputs)
	if (locale === "sv") return sv_jobs_discard(inputs)
	return en_jobs_discard(inputs)
});